import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { BatchSpanProcessor, ConsoleSpanExporter, SimpleSpanProcessor, SpanProcessor } from '@opentelemetry/sdk-trace-base';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { ZoneContextManager } from '@opentelemetry/context-zone-peer-dep';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import { resourceFromAttributes } from '@opentelemetry/resources';
import { ATTR_SERVICE_NAME, ATTR_SERVICE_VERSION } from '@opentelemetry/semantic-conventions';
import { W3CTraceContextPropagator } from '@opentelemetry/core';
import { environment } from './environments/environment';
import packageJson from '../package.json';

const config = environment.telemetry;

if (config.enabled) {
  const serviceVersion = config.serviceVersion || packageJson.version;

  const resource = resourceFromAttributes({
    [ATTR_SERVICE_NAME]: config.serviceName,
    [ATTR_SERVICE_VERSION]: serviceVersion,
  });

  const spanProcessors: SpanProcessor[] = [];

  spanProcessors.push(
    new BatchSpanProcessor(
      new OTLPTraceExporter({ url: config.collectorUrl })
    )
  );

  if (config.enableConsoleExporter) {
    spanProcessors.push(new SimpleSpanProcessor(new ConsoleSpanExporter()));
  }

  const provider = new WebTracerProvider({
    resource,
    spanProcessors,
  });

  provider.register({
    contextManager: new ZoneContextManager(),
    propagator: new W3CTraceContextPropagator(),
  });

  const corsUrlPatterns = config.propagateTraceHeaderCorsUrls.map((p: string) => new RegExp(p));

  registerInstrumentations({
    instrumentations: [
      getWebAutoInstrumentations({
        '@opentelemetry/instrumentation-document-load': {},
        '@opentelemetry/instrumentation-fetch': {
          propagateTraceHeaderCorsUrls: corsUrlPatterns,
          clearTimingResources: true,
        },
        '@opentelemetry/instrumentation-xml-http-request': {
          propagateTraceHeaderCorsUrls: corsUrlPatterns,
          clearTimingResources: true,
        },
        '@opentelemetry/instrumentation-user-interaction': {},
      }),
    ],
  });
}
